import React from 'react'
import TopBar from '../TopBar/TopBar'
import SidePanel from "../SidePanel/SidePanel";
// import Toast from "../Toast/Toast";

const TopBarWrapper = ( props ) => {
    return (
        <React.Fragment>
            <SidePanel/>
            {/*<Toast />*/ }
            <TopBar title={ props.title }/>
        </React.Fragment>
    )
}

export default TopBarWrapper;